export default {
  init() {
    /**
     * Set Swatch Value
     *
     * Sets the value of the selector for the variation that was clicked.
     *
     * @param selection Variation/Option that was clicked
     * @param selector Variation selector container
     */
    function set_swatch_value(selection, selector) {
      var value_input = selector.find('input.variation-value');
      var id_input = selector.find('input.variation-id');
      var selected_value = selector.find('.selected-value');
      value_input.val(selection.find('.option-title').html() + ' ' +
        selection.find('.option-added-cost').html());
      value_input.data('added-cost', selection.data('added-cost'));
      value_input.data('variation-id', selection.data('variation-id'));
      id_input.val(selection.data('variation-id'));
      selected_value.html(selection.html());
    }

    /**
     * Determine Dynamic Added Cost
     *
     * Finds the added dynamic price from the data-added-cost object.
     *
     * @param cost_value Contents of the data-added-cost attribute where the type if dynamic.
     * @param quantity Actual quantity in quantity field.
     * @returns {number} The added cost for the variation.
     */
    function determine_dynamic_added_cost(cost_value, quantity) {
      var added_cost = 0;
      $.each(cost_value, function(key, value) {
        if (parseInt(value.max)) {
          if (quantity >= parseInt(value.min) && quantity <=
            parseInt(value.max)) {
            added_cost = added_cost + (value.cost * 1);
          }
        } else {
          if (quantity >= parseInt(value.min)) {
            added_cost = added_cost + (value.cost * 1);
          }
        }
      });

      return added_cost;
    }

    function modify_price() {
      if ($('.single-product').length) {
        var qty_field = $('.quantity').find('input');
        //var price = $('.price');
        var variations = $('.variation.swatch-type');

        var quantity = 1;

        if (qty_field.val() != '0') {
          quantity = parseInt(qty_field.val());
        }

        var added_cost = 0;
        variations.each(function() {
          var input = $(this).find('input.variation-value');
          var variation_id = $(this).find('input.variation-id').val();
          var variation_link = $(this).
            find('a[data-variation-id=' + variation_id + ']');
          var cost = input.data('added-cost');
          if (variation_link.data('line-type') != 'orderline') {
            if (cost) {
              if (cost.type == 'static') {
                added_cost = added_cost + (cost.value * 1);
                console.log('Static value: ' + cost.value);
              } else if (cost.type == 'dynamic') {
                if (cost.value.length) {
                  added_cost = added_cost +
                    (determine_dynamic_added_cost(cost.value, quantity) * 1);
                }
              }
            }
          }
        });

        var price_field = $('p.price[data-pricing-table]');
        var price_span = price_field.find('.amount');
        var original_price_span = price_field.find('del .amount');
        var new_price_span = price_field.find('ins .amount');
        var pts = price_field.data('pricing-table');
        var base_price = window.accounting.unformat(price_span.html());
        var percentage_off = 0;
        var price_off = 0;
        if (pts) {
          $.each(pts, function(key, pt) {
            $.each(pt, function(key, value) {
              if (value.to) {
                if (quantity >= value.from && quantity <= value.to) {
                  if (value.type === 'percentage_discount') {
                    percentage_off += parseFloat(value.amount);
                  } else {
                    base_price = value.amount;
                  }
                }
              } else {
                if (quantity >= value.from) {
                  switch (value.type) {
                    case 'percentage_discount':
                      percentage_off += parseFloat(value.amount);
                      break;
                    case 'price_discount':
                      price_off += parseFloat(value.amount);
                      break;
                    case 'fixed_price':
                      base_price = value.amount;
                      break;
                  }
                }
              }
            });
          });
        }

        var price = window.accounting.unformat(added_cost) +
          window.accounting.unformat(base_price);
        var new_price = price;
        //console.log('Before discount: ' + price);
        //console.log('Percentage off: ' + percentage_off);
        //console.log('Amount off: ' + price_off);

        if (price_off > 0) {
          new_price = price - price_off;
        }

        if (percentage_off > 0) {
          percentage_off = (100 - percentage_off) / 100;
          new_price = new_price * percentage_off;
        }

        if (new_price < 0) {
          new_price = 0;
        }

        //console.log('Final price: ' + new_price);

        if (original_price_span.length && new_price_span.length) {
          original_price_span.html(window.accounting.formatMoney(price));
          new_price_span.html(window.accounting.formatMoney(new_price));
        } else {
          if (new_price) {
            price_span.html(window.accounting.formatMoney(new_price));
          } else {
            price_span.html(window.accounting.formatMoney(price));
          }
        }
      }
    }

    /**
     * Update Dynamic Variation Costs
     *
     * Loops through all swatch variations and updates the values based on the current quantity
     * if there is dynamic pricing for the selected variation option.
     */
    function update_dynamic_variation_costs() {
      var selectors = $('.variation-selector');
      if (selectors.length) {
        var qty = $('input.qty').val();
        selectors.find('.options > a').each(function() {
          var element = $(this);
          var added_cost = element.data('added-cost');
          if (added_cost.type == 'dynamic') {
            var cost = determine_dynamic_added_cost(added_cost.value, qty);
            if (cost) {
              element.find('.option-added-cost').
                html('(added cost of ' + window.accounting.formatMoney(cost) +
                  ')');
            }
          }
        });

        selectors.each(function() {
          var selector = $(this);
          var selection = selector.find('a[data-variation-id=' +
            selector.find('input.variation-value').data('variation-id') + ']');
          set_swatch_value(selection, selector);
        });
      }
    }

    /**
     * Modify Quantity
     *
     * Increments or decrements quantity if one of th eroller buttons is clicked.
     *
     * @param field Quantity field
     * @param type String containing increment or decerement.
     */
    function modify_qty(field, type) {
      var value = parseInt(field.val());
      if (isNaN(value)) {
        value = 0;
      }

      if (type === 'increment') {
        field.val(value + 1);
      } else if (type === 'decrement' && value > 0) {
        field.val(value - 1);
      } else {
        field.val(value);
      }
      if (parseInt(field.attr('min')) > parseInt(field.val())) {
        field.val(field.attr('min'));
      }

      update_dynamic_variation_costs();
    }

    /**
     * Collapses any open variation selecgtors except for the one that was clicked on.
     *
     * @param parent Recently opened swatch.
     */
    function collapse_all_variations(parent) {
      var container = $('.ad-cust-options');
      if (container.length) {
        var open = container.find('.swatch-type.open');
        open.each(function() {
          var swatch = $(this);
          if (swatch != parent) {
            var options = swatch.find('.options');
            options.slideUp();
            swatch.toggleClass('open');
          }
        });
      }
    }

    /**
     * Toggle Selector
     *
     * Toggles the clicked variation selector
     *
     * @param input Variation selector clickable input.
     */
    function toggle_selector(input) {
      var parent = input.closest('.variation');
      var options = parent.find('.options');
      var cover = $('.variation-cover');
      if (!cover.length) {
        cover = $('<div />').addClass('variation-cover').css('display', 'none');
        $('body').append(cover);
      }
      cover.click(function(e) {
        e.preventDefault();
        cover.hide();
        collapse_all_variations();
      });
      if (!parent.hasClass('open')) {
        collapse_all_variations(parent);
        cover.show();
        options.slideDown();
        parent.toggleClass('open');
      } else {
        cover.hide();
        collapse_all_variations();
      }
    }

    /**
     * Switch Swatch
     *
     * Updates the the tiny preview to the left of the inputs.
     *
     * @param selection Clicked variation option.
     * @param selector Variation selector
     */
    function switch_swatch(selection, selector) {
      var preview = selector.find('.preview');
      preview.html('');
      var data = selection.data('swatch');
      var div = $('<div />');
      if (data.type == 'color') {
        div.addClass('color').css('background', data.value);
        preview.append(div);
      } else if (data.type == 'image') {
        div.addClass('image');
        var img = $('<img />').attr('src', data.value).attr('alt', '');
        div.append(img);
        preview.append(div);
      }
    }

    /**
     * Set Popup Content
     *
     * Updates the content in the preview popup.
     *
     * @param selection Clicked variation option.
     * @param selector Variation selector
     */
    function set_popup_content(selection, selector) {
      var popup = selector.parent().find('.popup');
      var label = $('<div />').
        addClass('label').
        html(selection.find('.option-title').html());
      var data = selection.data('swatch');
      popup.html('');
      popup.append(label);
      if (data.type == 'color') {
        var color = $('<div />').
          addClass('color').
          css('background', data.value);
        popup.append(color);
      } else if (data.type == 'image') {
        var image = $('<img />').
          attr('src', data.value).
          attr('alt', selection.html());
        var div = $('<div />').addClass('image');
        div.append(image);
        popup.append(div);
      } else {
        var blank = $('<div />').addClass('color');
        popup.append(blank);
      }
    }

    var container = $('.ad-cust-options');
    if (container.length) {
      var swatch_types = container.find('.variation-selector');
      if (swatch_types.length) {
        swatch_types.find('.input').click(function(e) {
          e.preventDefault();
          toggle_selector($(this));
        });
        var options = swatch_types.find('a');
        options.click(function(e) {
          e.preventDefault();
          var selection = $(this);
          var selector = selection.closest('.variation-selector');
          set_swatch_value(selection, selector);
          if (selector.hasClass('has-swatches')) {
            switch_swatch(selection, selector);
          }
          toggle_selector(selector.find('.input'));
          set_popup_content(selection, selector);
          modify_price();
        });
        options.mouseover(function(e) {
          e.preventDefault();
          var selection = $(this);
          var selector = selection.closest('.variation-selector');
          if (selector.hasClass('has-swatches')) {
            set_popup_content(selection, selector);
          }
        });

      }
    }

    modify_price();

    var quantity_fields = $('input.qty');
    if (quantity_fields.length) {
      quantity_fields.each(function() {
        var qty = $(this);
        var container = qty.parent();

        qty.keydown(function(e) {
          // Allow: backspace, delete, tab, escape, enter and .
          if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
            // let it happen, don't do anything
            return;
          }
          // Ensure that it is a number and stop the keypress
          if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
            (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
          }
        });

        qty.keyup(function() {
          update_dynamic_variation_costs();
          modify_price();
        });

        qty.on('blur', function() {
          var qty = $(this);
          var value = qty.val();
          if (isNaN(value) || value == '') {
            qty.val('0');
          }
          update_dynamic_variation_costs();
          modify_price();
        });

        container.find('.increment').click(function(e) {
          e.preventDefault();
          modify_qty($(this).parent().find('input'), 'increment');
          modify_price();
        });
        container.find('.decrement').click(function(e) {
          e.preventDefault();
          modify_qty($(this).parent().find('input'), 'decrement');
          modify_price();
        });
      });
    }

    var secondary = $('.gallery');
    if (secondary.find('.padder > div').length) {
      var prevArrow = $('<button />').addClass('gallery-prev').html('Previous');
      var nextArrow = $('<button />').addClass('gallery-next').html('Next');
      let slick_padder = secondary.find('.padder');
      slick_padder.slick({
        appendDots: secondary,
        dots: true,
        dotsClass: 'gallery-dots',
        infinite: true,
        nextArrow: nextArrow,
        prevArrow: prevArrow,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 950,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 620,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 395,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

      secondary.append(prevArrow).append(nextArrow);



      var gallery_images = $('.gallery-image:not(.video)');
      if (gallery_images.length) {
        var image_links = gallery_images.find('a');
        image_links.hover(function() {
          var link = $(this);
          var primary_cont = link.closest('.product-images').find('.primary');
          var primary = primary_cont.find('img');
          var caption = primary_cont.find('.caption');
          primary.attr('src', link.data('image'));
          caption.html(link.find('img').data('description'));
          link.closest('.gallery').
            find('.gallery-image').
            find('a').
            removeClass('active');
          link.addClass('active');
        });

        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('thumb')) {
          let thumb_id = searchParams.get('thumb');
          slick_padder.slick('slickGoTo', thumb_id);

          let link = $('div.gallery-image[data-slick-index=' + thumb_id + '] a');

          let primary_cont = link.closest('.product-images').find('.primary');
          let primary = primary_cont.find('img');
          let caption = primary_cont.find('.caption');
          primary.attr('src', link.data('image'));
          caption.html(link.find('img').data('description'));
          link.closest('.gallery').
            find('.gallery-image').
            find('a').
            removeClass('active');
          link.addClass('active');
        }

        var gallery = $('.gallery');

        gallery.magnificPopup({
          delegate: '.slick-slide:not(.slick-cloned, .video) a', // the selector for gallery item
          type: 'image',
          image: {
            titleSrc: function(item) {
              return item.el.find('img').data('description');
            },
          },
          gallery: {
            enabled: true,
          },
        });

        var primary = gallery.parent().find('.primary');
        if (primary.length) {
          primary.find('.padder').click(function(e) {
            e.preventDefault();
            gallery.find('a.active').click();
          });

        }
      }
    }

    var dynamic_pricing_list = $('.dynamic-pricing-list');
    if (dynamic_pricing_list.length) {
      var expander = dynamic_pricing_list.find('.expander');
      expander.click(function(e) {
        e.preventDefault();
        var content = dynamic_pricing_list.find('.content-container');
        if (dynamic_pricing_list.hasClass('open')) {
          content.slideUp();
        } else {
          content.slideDown();
        }
        dynamic_pricing_list.toggleClass('open');
      });

      var price_discount_link = $('#view-quantity-discounts');
      if (price_discount_link.length) {
        price_discount_link.click(function(e) {
          e.preventDefault();
          if (!dynamic_pricing_list.hasClass('open')) {
            expander.click();
          }

          $('html, body').animate({
            scrollTop: dynamic_pricing_list.offset().top,
          });
        });
      }
    }

    var related_products = $('.related-products').find('.rp-rotator');
    if (related_products.find('ul.products').find('li').length) {
      var prodPrevArrow = $('<button />').
        addClass('product-prev').
        html('Previous');
      var prodNextArrow = $('<button />').addClass('product-next').html('Next');
      related_products.find('ul.products').slick({
        appendDots: related_products,
        dots: true,
        dotsClass: 'product-dots',
        infinite: true,
        nextArrow: prodNextArrow,
        prevArrow: prodPrevArrow,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
      related_products.append(prodPrevArrow).append(prodNextArrow);
      related_products.find('a').find('h2').matchHeight();
    }
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js